<template>
  <div id="app">
    <div class="xm-content">
      <router-view />
    </div>
    <div
      class="go-home"
      @click="handleGoHome"
    >
      工作台
    </div>
  </div>
</template>
<script>
  import EventBus from '@utils/eventBus'
  import { mapActions } from 'vuex'

  export default {
    created() {
      const clientId = window.__xm_wx.clientId
      if (clientId) {
        this.fetchClientVerifyInfo({
          client_id: clientId,
        })
        this.fetchUserInfo()
      }
    },
    mounted () {
      EventBus.$emit('app-load')
    },
    methods: {
      ...mapActions('main', ['fetchClientVerifyInfo','fetchUserInfo']),
      handleGoHome () {
        window.wx.miniProgram.navigateTo({
          url: '/pages/work/index'
        })
      }
    },
  }
</script>
<style lang="scss" scoped>
  body{
    padding-bottom: 0;
  }
  .xm-content{
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0;
    border-radius: 6px;
    background: #fff;
  }
  .go-home{
    position: fixed;
    right: 0;
    bottom: 80px;
    height: 28px;
    padding: 0 0.6em 0 1em;
    line-height: 28px;
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
    color: #fff;
    background: $base-color;
  }
</style>
